// eyeq — AI-категоризация некатегоризованных кадров (ADR-0079): раннер на VM
// гонит кадры через OpenRouter (порт eval_raw.py) и сдаёт вердикты пачками.
// Воркер применяет: clean → мета+категория (кадр появляется в QA-очереди),
// rejected → отказ с причиной (люди/брак — решение владельца 2026-08-31),
// needs_human → остаётся без категории с аудит-меткой (второй проход/человек).
import { z } from 'zod';
import { MeqCategorySchema, MeqSubCategorySchema } from './meta';

export const EyeqMapsEvalRowSchema = z.object({
  asset_id: z.string().min(1),
  verdict: z.enum(['clean', 'rejected', 'needs_human', 'error']),
  reject_reason: z.string().max(40).default(''),
  category: MeqCategorySchema.optional(),
  sub_category: MeqSubCategorySchema.optional(),
  subject_name: z.string().max(200).default(''),
  disambiguation_details: z.string().max(1000).default(''),
  place_details: z.string().max(200).default(''),
  has_text: z.boolean().default(false),
  indoor_outdoor: z.enum(['indoor', 'outdoor']).optional(),
  people_present: z.boolean().default(false),
  faces: z.number().int().nonnegative().default(0),
  confidence: z.number().min(0).max(1).default(0),
  error: z.string().max(120).default(''),
}).refine((v) => v.verdict !== 'clean' || (!!v.category && !!v.sub_category), {
  message: 'clean verdict requires category and sub_category',
});
export type EyeqMapsEvalRow = z.infer<typeof EyeqMapsEvalRowSchema>;

export const EyeqMapsCategorizeReqSchema = z.object({
  rows: z.array(EyeqMapsEvalRowSchema).min(1).max(50),
});
export type EyeqMapsCategorizeReq = z.infer<typeof EyeqMapsCategorizeReqSchema>;

export const EyeqMapsCategorizeResSchema = z.object({
  ok: z.boolean(),
  applied: z.number().int(),
  rejected: z.number().int(),
  needs_human: z.number().int(),
  errors: z.array(z.object({ asset_id: z.string(), note: z.string() })),
});
export type EyeqMapsCategorizeRes = z.infer<typeof EyeqMapsCategorizeResSchema>;

export const EyeqMapsUncatListResSchema = z.object({
  items: z.array(z.object({ asset_id: z.string(), locale: z.string() })),
});
export type EyeqMapsUncatListRes = z.infer<typeof EyeqMapsUncatListResSchema>;
